import type {
  TireQuoteNudgeCandidatesListApiData,
  TireQuoteNudgeCandidatesListApiResponses,
  TireQuoteNudgeDefaultBodiesListApiData,
  TireQuoteNudgeDefaultBodiesListApiResponses,
  TireQuoteNudgePreviewApiData,
  TireQuoteNudgePreviewApiResponses,
  TireQuoteNudgeSendApiData,
  TireQuoteNudgeSendApiResponses
} from '@navio/nsdk';
import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

/** Nudging customers who opened a tire offer but have not answered it. */
export const getTireOfferNudgeUrls = {
  getTireOfferNudgeCandidates: dataEndpoint<
    TireQuoteNudgeCandidatesListApiData,
    TireQuoteNudgeCandidatesListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('car-tire-quotes/nudge-candidates/', queryParams)
  }),
  getTireOfferNudgeDefaultBodies: dataEndpoint<
    TireQuoteNudgeDefaultBodiesListApiData,
    TireQuoteNudgeDefaultBodiesListApiResponses
  >({
    getUrl: () => apiUrl('car-tire-quotes/nudge-default-bodies/')
  }),
  postTireOfferNudgePreview: responseEndpoint<TireQuoteNudgePreviewApiData, TireQuoteNudgePreviewApiResponses>({
    getUrl: () => apiUrl('car-tire-quotes/nudge/preview/'),
    getBody: (data) => data
  }),
  postTireOfferNudge: responseEndpoint<TireQuoteNudgeSendApiData, TireQuoteNudgeSendApiResponses>({
    getUrl: () => apiUrl('car-tire-quotes/nudge/'),
    getBody: (data) => data
  })
};
